export const canPaste = (canPaste: boolean) => {
  return {
    type: 'CAN_PASTE',
    canPaste,
  };
};
